module.exports = require('./PageDialog');


/** WEBPACK FOOTER **
 ** ./demo/src/pages/dialog/index.js
 **/